<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="section-title mb-4">{{ $t("goodreturn") }}</div>

      <div class="d-flex">
        <div class="mb-2">
          <router-link
            v-if="$can('create', 'Goods Return')"
            variant="default"
            class="btn-blue"
            to="add-good-return"
            >{{ $tc("add") }}</router-link
          >
        </div>

        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex"></div>
          <div class="d-flex align-items-center">
            <div class="mx-2">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  <!-- Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp; -->
                  <strong>{{ viewingRange }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <button
              v-if="GridViewFlag"
              class="btnj btn-gridView mr-3"
              :class="gridView ? 'active' : ''"
              v-on:click="viewType('gridView')"
            ></button>
            <button
              v-if="GridViewFlag"
              class="btnj btn-listView"
              :class="listView ? 'active' : ''"
              v-on:click="viewType('listView')"
            ></button>
          </div>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 2) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="
                    onSelectCinema(cinema.cine_id, cinema.cine_name, cinema)
                  "
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("todate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="getAllReturnGoods()" class="btn-blue-lg w-100">
              {{ $tc("Get Report") }}
            </button>
          </div>

          <div
            v-if="Records && Records.length > 0"
            class="col-lg-4 col-xl-2 align-self-center mb-4 d-flex justify-content-end"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="goodsReturnPDF"
              :href="BASE_URL + goodsReturnPDF"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="goodsReturnExcel"
              :href="BASE_URL + goodsReturnExcel"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>

          <div class="px-2 w-25">
            <input
              autofocus
              v-model="search_value"
              v-on:change="getAllReturnGoods()"
              v-debounce:300="search_value"
              :placeholder="$t('Search...')"
              class="form-control form-control-sm"
              type="text"
            />
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $t("purchaseOrder") }}</th>
              <th>{{ $tc("rawmaterials", 1) }}</th>
              <th>{{ $tc("vendor", 1) }}</th>
              <th>Qty</th>
              <th>UOM</th>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("rate") }}</th>
              <th>{{ $t("amount") }}</th>
              <th>{{ $t("remarks") }}</th>
            </tr>
          </thead>
          <tbody v-if="Records && Records.length > 0" class="sph-report">
            <tr
              v-for="(singleRecord, singleRecordIndex) in Records"
              :key="singleRecordIndex"
            >
              <td style="text-align: right">{{ singleRecord.po_number }}</td>
              <td class="text-left">{{ singleRecord.rm_name }}</td>
              <td class="text-left">{{ singleRecord.v_name }}</td>
              <td style="text-align: right">
                {{ singleRecord.fgr_quantity.toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td class="text-left">{{ singleRecord.uom_short_form }}</td>
              <td>{{ singleRecord.fgr_return_date | dateparse }}</td>
              <td style="text-align: right">
                {{
                  singleRecord.fgr_return_rate
                    ? singleRecord.fgr_return_rate.toFixed(MIN_FRACTION_DIGITS)
                    : singleRecord.fgr_return_rate
                }}
              </td>
              <td style="text-align: right">
                {{
                  singleRecord.fgr_return_amount
                    ? singleRecord.fgr_return_amount.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    : singleRecord.fgr_return_amount
                }}
              </td>
              <td class="text-left">
                {{ singleRecord.fgr_remarks ? singleRecord.fgr_remarks : "-" }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="Records.length === 0" class="sph-report">
            <tr>
              <td colspan="9">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>
<script>
  import PosFnbService from "@/services/PosFnbService.js";
  import MasterService from "@/services/MasterService.js";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import moment from "moment";

  export default {
    // name: "Goods Return",
    components: {
      NoRecords,
    },
    data() {
      return {
        search_value: "",
        isHidden: false,
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        viewingnumbers: [],
        selected_cine_id: "",

        CinemasCopy: [],
        searchCinema: "",
        isRoleID: "",
        Records: [],
        Cinemas: [],
        selectedCinema: "",
        goodsReturnPDF: null,
        goodsReturnExcel: null,
        fromDate: new Date(),
        toDate: new Date(),
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      let role_is_cinema_level = this.secureStore.get("USINFO")
        .role_is_cinema_level;
      console.log("role_is_cinema_level :>> ", role_is_cinema_level);
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemasList(obj);
      this.getviewingnumber();

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selectedCinema = CinemaObj.cine_name;
        this.selected_cine_id = CinemaObj.cine_id;
        this.getAllReturnGoods(CinemaObj.cine_id);
      }
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.getAllReturnGoods(this.selected_cine_id);
        } else {
          this.currentPage = event;
          this.getAllReturnGoods(this.selected_cine_id);
        }
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemasList: function(cine_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selectedCinema = x.cine_name;
                  this.onSelectCinema(x.cine_id, x.cine_name, x);
                }
              });
            } else {
              this.$toasted.show(data.message);
              // this.isHidden = true;
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectCinema(cinema_id, cinema_name, cinema) {
        this.Records = [];
        this.selectedCinema = cinema_name;
        this.searchCinema = "";
        this.selected_cine_id = cinema_id;
        this.onSearchCinema();
        this.getAllReturnGoods(cinema_id);
        this.$store.dispatch("selectDropdownCinema", cinema);
      },
      getAllReturnGoods: function(cinema_id = this.selected_cine_id) {
        let loader = this.$loading.show();

        PosFnbService.GetAllGoodsReturn({
          cinema_id,
          cinema_name: this.selectedCinema,
          limit: this.perPage,
          currentPage: this.currentPage,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          search_value: this.search_value,
        })
          .then((response) => {
            this.Records = [];
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Records = data.Records;
                this.goodsReturnPDF = data.FinalPDFFile;
                this.goodsReturnExcel = data.FinalExcelFile;
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
    },
  };
</script>

<style scoped>
  .sph-report th,
  td {
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/GoodReturn/goodReturn.vue